/* Skyteck UX enhancements (design phase) */
(function () {
  // Collection: add a "Read more" toggle to the clamped SEO intro on mobile
  function collectionReadMore() {
    if (!/\/collections\//.test(location.pathname)) return;
    var d = document.querySelector('.collection-hero__description');
    if (!d || d.dataset.skReadmore) return;
    if (d.scrollHeight <= d.clientHeight + 8) return; // not overflowing at this width
    d.dataset.skReadmore = '1';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sk-readmore';
    btn.textContent = 'Read more';
    btn.addEventListener('click', function () {
      var expanded = d.classList.toggle('sk-expanded');
      btn.textContent = expanded ? 'Read less' : 'Read more';
    });
    d.insertAdjacentElement('afterend', btn);
  }

  // Perth notice block: hide for visitors whose saved estimator postcode is
  // outside WA (postcodes 6xxx); WA visitors and unknown visitors still see it.
  function perthNoticeGate() {
    var pc = '';
    try { pc = localStorage.getItem('sk_postcode') || ''; } catch (e) { /* private mode */ }
    if (!/^\d{4}$/.test(pc)) return; // unknown or junk postcode: keep showing the notice
    if (/^6\d{3}$/.test(pc)) return; // WA visitor: notice applies
    var headings = document.querySelectorAll('h1,h2,h3,h4');
    for (var i = 0; i < headings.length; i++) {
      if (/Perth Customers Notice/i.test(headings[i].textContent)) {
        // Hide the whole styled block — the outer <perth-notice-*> custom element,
        // not the inner div: background + border live on the outer element, so
        // hiding only the inner content left an empty grey box.
        var box = headings[i].closest('[class*="ai-perth-notice"]') || headings[i].closest('div');
        while (box.parentElement && /^perth-notice-/i.test(box.parentElement.tagName)) box = box.parentElement;
        box.style.display = 'none';
        return;
      }
    }
  }

  function init() {
    collectionReadMore();
    perthNoticeGate();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
